import axios from 'axios'
import store from '../store'
import { Message, MessageBox } from "element-ui";
import vm from '../main'
import { url, url2, productionBaseUrl } from './axiosUrl'

// read env from configs file
// const env = window['$env'] ? window['$env'] : process.env.NODE_ENV
const util = {}
// util.baseUrl = process.env.NODE_ENV === 'development' ? url55 + ':9997' : url55 + ':9997'
util.baseUrl = process.env.NODE_ENV === 'development' ? url + ':9200' : productionBaseUrl + ':9200'
// export const axiosOne = process.env.NODE_ENV === 'development' ? url55 + ':9998' : url55 + ':9998'
export const axiosOne = process.env.NODE_ENV === 'development' ? url2 + ':9100' : productionBaseUrl + ':9100'
// export const axiosTWo = process.env.NODE_ENV === 'development' ? url55 + ':9997' : url55 + ':9997'
export const axiosTWo = process.env.NODE_ENV === 'development' ? url2 + ':9200' : productionBaseUrl + ':9200'
// export const axiosThree = process.env.NODE_ENV === 'development' ? url58 + ':9300' : url58 + ':9300'
export const axiosThree = process.env.NODE_ENV === 'development' ? url2 + ':9300' : productionBaseUrl + ':9300'
// export const axiosFour = process.env.NODE_ENV === 'development' ? url2 + ':9002' : productionBaseUrl + ':9002'
// export const axiosFour = process.env.NODE_ENV === 'development' ? url2 + ':9400' : productionBaseUrl + ':9400'
export const axiosFour = process.env.NODE_ENV === 'development' ? url2 + ':9002' : productionBaseUrl + ':9002'

util.http = axios.create({
    baseURL: util.baseUrl,
    timeout: 120000,
    withCredentials: true // 运行跨域带上cookies
});//axios的另一个重写方法
util.getAjaxUrl = function (type) {
    switch (type) {
        case 'axiosOne':
            return axiosOne
        case 'axiosTWo':
            return axiosTWo
        case 'axiosThree':
            return axiosThree
        case 'axiosFour':
            return axiosFour
        default:
            return util.baseUrl
    }
}

// http请求拦截
util.http.interceptors.request.use(function (config) {

    config.cancelToken = new axios.CancelToken(cancel => {
        store.commit('app/pushToken', {
            cancelToken: cancel
        })
    })
    return config
}, function (error) {
    // 请求失败的处理
    return Promise.reject(error)
})

// http响应拦截
util.http.interceptors.response.use(function (res) {
    // console.log(res);

    // 在这里对返回的数据进行处理
    if (!res.config.url.includes('refreshToken')) {
        // 记录ajax调用的时间
        sessionStorage.lastHttpRequestTime = +new Date()
    }
    return res
}, function (error) {
    // Do something with response error
    if (error.response) {
        switch (error.response.status) {
            case 403:
                Message.error(error.response.data.message)
                break
            case 408:
                Message.error("网络连接超时，请重试！")
                break
            default:
                return Promise.reject(error)
        }
    } else if (error.message) {
        if (error.message === 'Network Error') {
            Message.error('网络连接错误，请检查网络环境！')
        } else if (error.message.indexOf('timeout') >= 0) {
            Message.error('网络连接超时，请重试！')
        } else {
            Message.error(error.message)
        }
    } else {
        Message.error('未知错误，请联系管理员！')
    }
})
util.ajaxWithFile = function (url, method, params, type) {
    return new Promise((resolver, reject) => {
        var res = resolver;
        util.http({
            baseURL: util.getAjaxUrl(type),
            method: method,
            url: url,
            data: params,
            responseType: 'blob',
        }).then(response => {
            res(response);
        }).catch((error) => {
            reject(error);
        });
    })
};
util.downloadFile = function (data, fileName) {
    var blob = new Blob([data])
    if (window.navigator.msSaveBlob) {
        try {
            window.navigator.msSaveBlob(blob, fileName)
        } catch (e) {
            console.log(e);
        }
    } else {
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
    }
}
util.judgeFileType = function (file, acceptFileTypeLists) {
    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
    return acceptFileTypeLists.findIndex(item => {
        return item === fileType
    })
}
export default util;
